import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import axios from 'axios';
// TODO restructure all this utils should not be here ...
// TODO THIS SHOULD BE CACHED (https://www.npmjs.com/package/axios-cache-adapter) ??
export const getBlobUrl = (url, config) => axios.get(url, _objectSpread({
  responseType: 'blob',
  withCredentials: true
}, config));
export const getDownloadProgressLength = e => {
  return e.loaded ? e.total : e.event.getResponseHeader('content-length') || e.event.getResponseHeader('x-decompressed-content-length');
};
export const getDownloadProgress = e => {
  const totalLength = getDownloadProgressLength(e);
  if (totalLength) {
    return {
      loaded: e.loaded,
      total: totalLength,
      percentage: Math.round(e.loaded * 100 / totalLength)
    };
  }
  return null;
};
export const useUrl = (url, config) => {
  const [blob, setBlob] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [load, setLoad] = React.useState(null);
  const [error, setError] = React.useState(null);
  React.useEffect(() => {
    setLoading(true);
    getBlobUrl(url, _objectSpread(_objectSpread({}, config), {}, {
      onDownloadProgress: e => {
        const progress = getDownloadProgress(e);
        if (progress) setLoad(progress);
      }
    })).then(({
      data
    }) => setBlob(data)).catch(e => setError(e)).finally(() => setLoading(false));
  }, [url]);
  return {
    blob,
    loading,
    error,
    load
  };
};